<template>
 <div class="bg-[#23242A] text-white app-header p-3 custom">

    <div :class="'lg:p-3 p-1 flex content-main gap-5' + (action.component ? ' half-it' : '')">
      
      <div class="custom-full custom-left">
        <div class="bg-[#2B2C32] rounded-lg px-[16px] max-w-full py-[16px]">

      
          <div class="flex justify-between mb-5">
            <h2 class="text-[24px] font-semibold text-white">Taxes &amp; Fees Settings</h2>
            <div v-if="can_edit_tax">
              <div class="relative" tabindex="0">
                <div @click="addUpdate({ component: 'Add', data: {}})" v-if="!action.component" class="text-white bg-theme-green hover:bg-green-600 py-1 h-10 px-1 text-2xl border-0 rounded-md cursor-pointer">
                  <span>
                    <svg fill="currentColor" width="32" height="32" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z"></path>
                    </svg>
                  </span>
                </div>
              </div>
            </div>
              <!-- <mdicon @click="addUpdate({ component: 'Add', data: {}})" v-if="!action.component" size="32" name="plus" class="text-white bg-theme-green hover:bg-theme-darkgreen py-1 h-10 px-1 text-2xl border-0 rounded-md cursor-pointer"/></div> -->
          </div>
          <List :selectedCallback="selectedItem" :clearComponent="clearComponent" :iscomponentactive="action.component ? true : false"/>
        </div>
      </div>
  
      <div :class="'w-full hidden-component custom-right'" v-if="action.component" >
        <component :is="action.component" :item="action.data" :clearComponent="clearComponent"></component>
      </div>

  </div>
  </div>
</template>


<script lang="ts">
import {defineComponent, ref} from "vue"
import { mapGetters, mapActions, mapMutations } from "vuex";
import List from '@/views/Tax/List.vue';
import Add from '@/views/Tax/Add.vue';
import Update from '@/views/Tax/Update.vue';
import Helpers from '@/helpers';
import router from '@/router';

  export default defineComponent({
  name: "Taxes",
  components: {
    List,
    Add,
    Update,
  },

  setup() {
    const action = ref<object>({
      component: '',
      data: {},
    });
    return {
      action,
    };
  },

  watch : {
    'vg_selectedLocation'(val) {
      if(this.vg_userToken){
        // if location selected clear component
        this.clearComponent();
      }else{
        router.push('/login?sessionExpired=1')
      }
    },
  },

  computed: {
    /**
     * Edit restriction
     */
    can_edit_tax() {
      return Helpers.getMyPermission('can_manage_taxes')
    },
    ...mapGetters({
     vg_userToken: 'auth/userToken',
     vg_selectedLocation: 'location/selected'
    }),
  },

  mounted() {
    this.emitter.on("reset-location-tax-component", data => {
      this.clearComponent();
    });
  },

  beforeDestroy() {
    this.emitter.off('reset-location-tax-component', () => {});
    this.emitter.off('refresh-location-tax-list', () => {});
  },
 
  methods: {
    /**
     * Clear action
     */
    clearComponent() {
      this.action = {
        component: '',
        data: {},
      };
      let activeItem = document.getElementsByClassName('active-row');
      if(activeItem.length > 0){
        activeItem[0].classList.remove("active-row");
      }
    },

    /**
     * Change add / update component
     */
    addUpdate(val: any) {
      this.action = val;
    },

    /**
     * Capture selected item
     */
    selectedItem(item) {
      this.addUpdate({
        component: 'Update', 
        data: item
      })
    },

    ...mapActions({
      va_spinner: 'spinner/setSpinner',
    })
  },
});

</script>